import styled from 'styled-components';
import { breakpoints } from '@src/common/breakpoints';
import { LayoutColors } from '@src/core/theme';

export const Challenge3dsWrapper = styled.div`
  /* Display none needed to avoid element showing up before Pagar.me injects the iframe */
  display: none;
  transition: 0.3s ease-in-out;
  width: 100%;
  height: 100%;
  z-index: 999999999;
  position: relative;
`;

export const Challenge3dsModalBackdrop = styled.div`
  position: fixed;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
`;

export const Challenge3dsContent = styled.div`
  width: 600px;
  height: 80%;
  overflow-y: auto;

  iframe {
    width: 100%;
    height: 100%;
    background-color: ${LayoutColors.whiteDark};
  }

  @media (max-width: ${breakpoints.smallTablet}) {
    width: 90%;
  }
`;
